<template>
  <div class="workflow-step">
    <div class="step-number">{{ stepNumber }}</div>
    <div class="step-content">
      <h3 class="step-title">{{ title }}</h3>
      <p class="step-description">{{ description }}</p>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorkflowStep',
  props: {
    stepNumber: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
@import './styles/WorkflowStep.css';
</style>




// WEBPACK FOOTER //
// WorkflowStep.vue?42334cfc